module.exports = __webpack_public_path__ + "static/financial_access2-24458152d299c060da81a0df695c1e63.png";